export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_VERIFIED = 'SET_USER_VERIFIED'
export const SET_HAVE_TOKEN = 'SET_HAVE_TOKEN'
export const SET_HAS_PASSWORD = 'SET_HAS_PASSWORD'
export const SET_HAS_PHONE = 'SET_HAS_PHONE'
export const SET_PROMPT_TO_SET_PASSWORD = 'SET_PROMPT_TO_SET_PASSWORD'
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS'
export const SET_USER_SETTINGS_PROMISE = 'SET_USER_SETTINGS_PROMISE'
export const SET_FIREBASE_TOKEN = 'SET_FIREBASE_TOKEN'
export const SET_CLOUD_MESSAGING_TOKEN = 'SET_CLOUD_MESSAGING_TOKEN'
export const SET_SHOW_SIGNUP_SURVEY = 'SET_SHOW_SIGNUP_SURVEY'
export const SET_SHOW_SIGNUP_CATEGORIES = 'SET_SHOW_SIGNUP_CATEGORIES'
export const SET_LIMITED_USER = 'SET_LIMITED_USER'
export const SET_REFERRAL_CODE = 'SET_REFERRAL_CODE'
export const SET_USER_CATEGORIES = 'SET_USER_CATEGORIES'
export const SET_USER_FILTER_TAGS = 'SET_USER_FILTER_TAGS'
export const RESET_USER_FILTER_TAGS = 'RESET_USER_FILTER_TAGS'
export const GET_FILTER_OPTION = 'GET_FILTER_OPTION'
export const SET_USER_FILTER_TAGS_REMEMBER = 'SET_USER_FILTER_TAGS_REMEMBER'
export const SET_USER_AWARDS = 'SET_USER_AWARDS'
export const HAS_AJAS_ROLE = 'HAS_AJAS_ROLE'
export const HAS_YSC_INFO = 'HAS_YSC_INFO'
export const HAS_PARTNER_INFO = 'HAS_PARTNER_INFO'
export const HAS_CLICKED_RESOURCE_BUTTON = 'HAS_CLICKED_RESOURCE_BUTTON'
export const HAS_REGISTERED = 'HAS_REGISTERED'
export const RESOURCE_BUTTON_TEXT = 'RESOURCE_BUTTON_TEXT'
export const IS_SIGNUP_COMPLETE = 'IS_SIGNUP_COMPLETE'
export const IS_SIGNING_UP = 'IS_SIGNING_UP'
export const SET_HANDLES = 'SET_HANDLES'
export const DELETE_HANDLE = 'DELETE_HANDLE'
export const SAVE_HANDLE = 'SAVE_HANDLE'

export const SET_TEACHER_GROUP = 'SET_TEACHER_GROUP'
export const SET_TEACHER_CLASSES = 'SET_TEACHER_CLASSES'
export const UPDATE_TEACHER_CLASS = 'UPDATE_TEACHER_CLASS'
export const SET_STUDENT_LIST = 'SET_STUDENT_LIST'
export const UPDATE_STUDENT = 'UPDATE_STUDENT'
export const CLEAR_STUDENTLIST = 'CLEAR_STUDENTLIST'
export const REMOVE_STUDENT = 'DELETE_STUDENT'
export const TEACHER_CODE = 'TEACHER_CODE'
export const CLEAR_TEACHER_CLASSES = 'CLEAR_TEACHER_CLASSES'
export const SET_STUDENT_QUESTION_ID = 'SET_STUDENT_QUESTION_ID'
export const SET_STUDENT_NAME = 'SET_STUDENT_NAME'
export const SET_JUDGE_APPLICATION_DATA = 'SET_JUDGE_APPLICATION_DATA'
export const CLEAR_JUDGE_APPLICATION = 'CLEAR_JUDGE_APPLICATION'

export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT_POST_MILESTONE_COUNT = 'UPDATE_PROJECT_POST_MILESTONE_COUNT'
export const SET_JUDGE_PROJECTS = 'SET_JUDGEPROJECTS'
export const ADD_APPROVEDPROJECT = 'ADD_APPROVEDPROJECT'
export const SET_APPROVED_PROJECTS = 'SET_APPROVED_PROJECTS'
export const ADD_PENDINGPROJECT = 'ADD_PENDINGPROJECT'
export const SET_PENDING_PROJECTS = 'SET_PENDING_PROJECTS'
export const ADD_DECLINEDPROJECT = 'ADD_DECLINEDPROJECT'
export const SET_DECLINED_PROJECTS = 'SET_DECLINED_PROJECTS'
export const REMOVE_PENDINGPROJECT = 'REMOVE_PENDINGPROJECT'
export const REMOVE_APPROVEDPROJECT = 'REMOVE_APPROVEDPROJECT'
export const REMOVE_DECLINEDPROJECT = 'REMOVE_DECLINEDPROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const ADD_NEW_PROJECT_ID = 'ADD_NEW_PROJECT_ID'
export const CLEAR_NEW_PROJECT_IDS = 'CLEAR_NEW_PROJECT_IDS'
export const SET_PROJECT_GROUP = 'SET_PROJECT_GROUP'
export const ADD_PINNED_PROJECT = 'ADD_PINNED_PROJECT'
export const REMOVE_PINNED_PROJECT = 'REMOVE_PINNED_PROJECT'
export const UPDATE_PROJECT_TAGS = 'UPDATE_PROJECT_TAGS'
export const UPDATE_SELECTED_ANSWER_TAGS = 'UPDATE_SELECTED_ANSWER_TAGS'
export const UPDATE_SELECTED_CARD_FIELDS = 'UPDATE_SELECTED_CARD_FIELDS'
export const USERS_NOT_COMPLETED_QUESTIONS = 'USERS_NOT_COMPLETED_QUESTIONS'
export const ADD_QRCODE = 'ADD_QRCODE'
export const ADD_SUBMISSION_STATUS = 'ADD_SUBMISSION_STATUS'
export const CLEAR_SUBMISSION_STATUS = 'CLEAR_SUBMISSION_STATUS'

export const ADD_CATEGORIES = 'ADD_CATEGORIES'
export const UPDATE_SELECTED_LANGUAGE = 'UPDATE_SELECTED_LANGUAGE'
export const CLEAR_CATEGORIES = 'CLEAR_CATEGORIES'
export const UPDATE_LOADING = 'UPDATE_LOADING'
export const IDENTIFY_PAGE = 'IDENTIFY_PAGE'

export const LIKE_PROJECT = 'LIKE_PROJECT'
export const UNLIKE_PROJECT = 'UNLIKE_PROJECT'
export const LIKED_PROJECT = 'LIKED_PROJECT'
export const LIKED_PROJECTS_CACHED = 'LIKED_PROJECTS_CACHED'

export const ADD_COMMENT = 'ADD_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const UPDATE_COMMENT = 'UPDATE_COMMENT'

export const LIKE_COMMENT = 'LIKE_COMMENT'
export const UNLIKE_COMMENT = 'UNLIKE_COMMENT'
export const LIKED_COMMENT = 'LIKED_COMMENT'
export const LIKED_COMMENTS_CACHED = 'LIKED_COMMENTS_CACHED'

export const ADD_REPLY = 'ADD_REPLY'
export const ADD_PROJECT_COMMENT = 'ADD_PROJECT_COMMENT'
export const ADD_POST_COMMENT = 'ADD_POST_COMMENT'
export const UPDATE_COMMENT_REPLY_COUNT = 'UPDATE_COMMENT_REPLY_COUNT'
export const UPDATE_PROJECT_COMMENT_COUNT = 'UPDATE_PROJECT_COMMENT_COUNT'
export const UPDATE_POST_COMMENT_COUNT = 'UPDATE_POST_COMMENT_COUNT'
export const UPDATE_COMPLETED_POST_COUNT = 'UPDATE_COMPLETED_POST_COUNT'

export const ADD_COMMENT_ATTACHMENT = 'ADD_COMMENT_ATTACHMENT'
export const UPDATE_COMMENT_ATTACHMENT = 'UPDATE_COMMENT_ATTACHMENT'
export const DELETE_COMMENT_ATTACHMENT = 'DELETE_COMMENT_ATTACHMENT'

export const CLEAR_LINKED_PROJECTS = 'CLEAR_LINKED_PROJECTS'
export const ADD_LINKED_PROJECT = 'ADD_LINKED_PROJECT'
export const REMOVE_LINKED_PROJECT = 'REMOVE_LINKED_PROJECT'
export const UPDATE_PROJECT_TEMPLATE_SETTINGS = 'UPDATE_PROJECT_TEMPLATE_SETTINGS'

export const SESSION_ADD = 'SESSION_ADD'
export const SESSION_DEL = 'SESSION_DEL'

export const IS_PROJ_ON_ENG = 'IS_PROJ_ON_ENG'

export const COMPONENT_ADD = 'COMPONENT_ADD'
export const COMPONENT_DEL = 'COMPONENT_DEL'
export const COMPONENT_PUSH = 'COMPONENT_PUSH'
export const COMPONENT_POP = 'COMPONENT_POP'
export const COMPONENT_CALLBACK = 'COMPONENT_CALLBACK'
export const COMPONENT_CALLBACK_DEL = 'COMPONENT_CALLBACK_DEL'

export const ADD_PROFILE = 'ADD_PROFILE'
export const MOVE_PROFILE = 'MOVE_PROFILE'
export const SET_SKILLS = 'SET_SKILLS'
export const SET_INTERESTS = 'SET_INTERESTS'
export const ADD_PROFILE_COUNT = 'ADD_PROFILE_COUNT'

export const ADD_MEMBER = 'ADD_MEMBER'
export const ADD_NEW_TEAM_MEMBER = 'ADD_NEW_TEAM_MEMBER'
export const REMOVE_MEMBER = 'REMOVE_MEMBER'
export const ADD_POSTMEMBER = 'ADD_POSTMEMBER'
export const REMOVE_POSTMEMBER = 'REMOVE_POSTMEMBER'

export const SOCKET_ONOPEN = 'SOCKET_ONOPEN'
export const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE'
export const SOCKET_ONERROR = 'SOCKET_ONERROR'
export const SOCKET_ONMESSAGE = 'SOCKET_ONMESSAGE'
export const SOCKET_SUBSCRIBE = 'SOCKET_SUBSCRIBE'
export const SOCKET_UNSUBSCRIBE = 'SOCKET_UNSUBSCRIBE'
export const SOCKET_UUID = 'SOCKET_UUID'

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'

export const SUBSCRIBE_PROJECT = 'SUBCRIBE_PROJECT'
export const SUBSCRIBED_TO_PROJECT = 'SUBCRIBED_TO_PROJECT'
export const UNSUBSCRIBE_PROJECT = 'UNSUBSCRIBE_PROJECT'
export const SUBSCRIBED_PROJECTS_CACHED = 'SUBSCRIBED_PROJECTS_CACHED'

export const ADD_CONVERSATION = 'ADD_CONVERSATION'
export const SET_CONVERATION_HAS_MORE_MESSAGES = 'SET_CONVERATION_HAS_MORE_MESSAGES'
export const ADD_MESSAGE_BEFORE = 'ADD_MESSAGE_BEFORE'
export const ADD_MESSAGE_AFTER = 'ADD_MESSAGE_AFTER'
export const SET_CONVERSATIONS_METADATA = 'SET_CONVERSATIONS_METADATA'
export const SET_DRAFT_CONVERSATION = 'SET_DRAFT_CONVERSATION'
export const INCOMING_MESSAGE = 'INCOMING_MESSAGE'
export const SORT_CONVERSATIONS = 'SORT_CONVERSATIONS'
export const SET_UNREAD_CONVERSATIONS_COUNT = 'SET_UNREAD_CONVERSATIONS_COUNT'
export const SET_CONVERSATION_UNREAD = 'SET_CONVERSATION_UNREAD'
export const SET_UNREAD_NOTIFICATIONS_COUNT = 'SET_UNREAD_NOTIFICATIONS_COUNT'
export const INCR_UNREAD_NOTIFICATIONS_COUNT = 'INCR_UNREAD_NOTIFICATIONS_COUNT'
export const DECR_UNREAD_NOTIFICATIONS_COUNT = 'DECR_UNREAD_NOTIFICATIONS_COUNT'
export const RESET_UNREAD_NOTIFICATIONS_COUNT = 'RESET_UNREAD_NOTIFICATIONS_COUNT'
export const ADD_PUBLIC_CONVERSATION = 'ADD_PUBLIC_CONVERSATION'
export const SET_PUBLIC_CONVERSATIONS_METADATA = 'SET_PUBLIC_CONVERSATIONS_METADATA'

export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'

export const RESET_ON_LOGOUT = 'RESET_ON_LOGOUT'
export const RESET_ON_FEED = 'RESET_ON_FEED'

export const SET_MODAL_VISIBILITY = 'SET_MODAL_VISIBLE'
export const SET_MODAL_DATA = 'SET_MODAL_DATA'

export const ADD_POST = 'ADD_POST'

export const SET_EDITED = 'SET_EDITED'

export const LIKED_MESSAGE = 'LIKED_MESSAGE'
export const UPDATE_MESSAGE_LIKECOUNT = 'UPDATE_MESSAGE_LIKECOUNT'
export const DELETE_POST = 'DELETE_POST'
export const LIKED_MESSAGES_CACHED = 'LIKED_MESSAGES_CACHED'

export const LIKE_POST = 'LIKE_POST'
export const UNLIKE_POST = 'UNLIKE_POST'
export const LIKED_POST = 'LIKED_POST'
export const LIKED_POSTS_CACHED = 'LIKED_POSTS_CACHED'

export const ADD_PROJECT_POST = 'ADD_PROJECT_POST'
export const CLEAR_PROJECT_POSTS = 'CLEAR_PROJECT_POSTS'
export const UPDATE_PROJECT_POST_COUNT = 'UPDATE_PROJECT_POST_COUNT'

export const ADD_POST_ATTACHMENT = 'ADD_POST_ATTACHMENT'
export const UPDATE_POST_ATTACHMENT = 'UPDATE_POST_ATTACHMENT'
export const DELETE_POST_ATTACHMENT = 'DELETE_POST_ATTACHMENT'
export const ADD_NEW_POST_ID = 'ADD_NEW_POST_ID'
export const SET_POST_TYPE = 'SET_POST_TYPE'
export const SORT_ATTACHMENTS_FOR_POST = 'SORT_ATTACHMENTS_FOR_POST'
export const SORT_ATTACHMENTS_FOR_COMMENT = 'SORT_ATTACHMENTS_FOR_COMMENT'
export const UPDATE_POST_PROJECT_SETTINGS = 'UPDATE_POST_PROJECT'
export const UPDATE_POST_SETTINGS = 'UPDATE_POST_SETTINGS'
export const UPDATE_POST_STATUS = 'UPDATE_POST_STATUS'
export const COMPLETED_MILESTONE_POST_COUNT = 'COMPLETED_MILESTONE_POST_COUNT'
export const SET_ATTACHMENT_VIDEO_STATUS = 'SET_ATTACHMENT_VIDEO_STATUS'
export const RESET_ATTACHMENT_VIDEO_STATUS = 'RESET_ATTACHMENT_VIDEO_STATUS'

export const ADD_COMMUNITY_POLL = 'ADD_COMMUNITY_POLL'
export const INIT_POLL_USRE_OPTION_SUMMARIES = 'INIT_POLL_USRE_OPTION_SUMMARIES'

export const ADD_USER_POST = 'ADD_USER_POST'
export const CLEAR_USER_POSTS = 'CLEAR_USER_POSTS'

export const ADD_AWARD = 'ADD_AWARD'
export const ADD_SSD_AWARD = 'ADD_SSD_AWARD'
export const CLEAR_AWARDS = 'CLEAR_AWARDS'

export const UPDATE_POST_BODY = 'UPDATE_POST_BODY'
export const UPDATE_POST_PRIORITY = 'UPDATE_POST_PRIORITY'

export const UPDATE_CREATING_COMMENT = 'UPDATE_CREATING_COMMENT'

export const ADD_PROVINCE = 'ADD_PROVINCE'
export const CLEAR_PROVINCES_AND_REGIONS = 'CLEAR_PROVINCES_AND_REGIONS'
export const UPDATE_REGION_INFO = 'UPDATE_REGION_INFO'

export const DELETE_BANNER = 'DELETE_BANNER'
export const DELETE_SPONSOR = 'DELETE_SPONSOR'
export const ADD_BANNER = 'ADD_BANNER'
export const ADD_SPONSOR = 'ADD_SPONSOR'
export const ADD_IFRAME = 'ADD_IFRAME'
export const ADD_SECTION = 'ADD_SECTION'
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE'
export const ADD_FAIR = 'ADD_FAIR'
export const ELIGIBLE_FAIRS = 'ELIGIBLE_FAIRS'
export const REMOVE_FROM_ELIGIBLE_FAIRS = 'REMOVE_FROM_ELIGIBLE_FAIRS'
export const CLEAR_FAIRS = 'CLEAR_FAIRS'
export const ADD_EVENTS = 'ADD_EVENTS'

export const ADD_USER_PIN = 'ADD_USER_PIN'
export const ADD_PROJECT_PIN = 'ADD_PROJECT_PIN'
export const PARTNER_RESOURCES = 'PARTNER_RESOURCES'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'
export const DELETE_SECTION = 'DELETE_SECTION'
export const CLEAR_RESOURCESLIST = 'CLEAR_RESOURCESLIST'
export const CLEAR_SECTIONLIST = 'CLEAR_SECTIONLIST'

export const INITIALIZE_UTM_FROM_LOCAL_STORAGE = 'INITIALIZE_UTM_FROM_LOCAL_STORAGE'
export const SET_UTM_PARAM = 'SET_UTM_PARAM'
export const CLEAR_UTM_PARAM = 'CLEAR_UTM_PARAM'
export const SET_UTM_SIGNUP_METHOD = 'SET_UTM_SIGNUP_METHOD'
export const SET_UTM_TRACKED = 'SET_UTM_TRACKED'

export const CLEAR_PARTNERS = 'CLEAR_PARTNERS'
export const ADD_PARTNER = 'ADD_PARTNER'
export const ADD_PARTNER_PAGE_INFO = 'ADD_PARTNER_PAGE_INFO'
export const UPDATE_PARTNER_PAGE_INFO = 'UPDATE_PARTNER_PAGE_INFO'
export const DELETE_PARTNER_PAGE_INFO = 'DELETE_PARTNER_PAGE_INFO'
export const SET_SIGNUP_NAMES = 'SET_SIGNUP_NAMES'

export const UPDATE_USER_TYPE_ERROR = 'UPDATE_USER_TYPE_ERROR'
export const UPDATE_USER_TYPE_SUCCESS = 'UPDATE_USER_TYPE_SUCCESS'
export const UPDATE_EVENT_AND_PARTNER_IDS_ERROR = 'UPDATE_EVENT_AND_PARTNER_IDS_ERROR'
export const UPDATE_EVENT_AND_PARTNER_IDS_SUCCESS = 'UPDATE_EVENT_AND_PARTNER_IDS_SUCCESS'
export const ADD_GROUP = 'ADD_GROUP'
export const SET_ONBOARDING_TYPE = 'SET_ONBOARDING_TYPE'
export const SET_ONBOARDING_COLOR = 'SET_ONBOARDING_COLOR'
export const INIT_ONBOARDING = 'INIT_ONBOARDING'
export const SET_DISABLE_SCREEN = 'SET_DISABLE_SCREEN'
export const SET_ONBOARDING_STARTED = 'SET_ONBOARDING_STARTED'
export const INIT_ONBOARDING_COMPLETED = 'INIT_ONBOARDING_COMPLETED'
export const SET_ONBOARDING_COMPLETED = 'SET_ONBOARDING_COMPLETED'

export const UPDATE_SHOW_WIDGET = 'UPDATE_SHOW_WIDGET'
export const SET_BROWSER_WARNING = 'SET_BROWSER_WARNING'

export const JUDGING_POLLS_LOADED = 'JUDGING_POLLS_LOADED'
export const JUDGING_POLLS_LOADING = 'JUDGING_POLLS_LOADING'
export const JUDGING_POLLS_ERROR = 'JUDGING_POLLS_ERROR'

export const POLL_USER_OPTIONS_IDLE = 'POLL_USER_OPTIONS_IDLE'
export const POLL_USER_OPTIONS_LOADING = 'POLL_USER_OPTIONS_LOADING'
export const POLL_USER_OPTIONS_LOADED = 'POLL_USER_OPTIONS_LOADED'
export const POLL_USER_OPTIONS_ERROR = 'POLL_USER_OPTIONS_ERROR'

export const POLL_QUESTIONS_IDLE = 'POLL_QUESTIONS_IDLE'
export const POLL_QUESTIONS_LOADING = 'POLL_QUESTIONS_LOADING'
export const POLL_QUESTIONS_LOADED = 'POLL_QUESTIONS_LOADED'
export const POLL_QUESTIONS_ERROR = 'POLL_QUESTIONS_ERROR'

export const POLL_QUESTIONS_FILTER_IDLE = 'POLL_QUESTIONS_FILTER_IDLE'
export const POLL_QUESTIONS_FILTER_LOADING = 'POLL_QUESTIONS_FILTER_LOADING'
export const POLL_QUESTIONS_FILTER_LOADED = 'POLL_QUESTIONS_FILTER_LOADED'
export const POLL_QUESTIONS_FILTER_ERROR = 'POLL_QUESTIONS_FILTER_ERROR'

export const JUDGING_TAB_SWITCHED = 'JUDGING_TAB_SWITCHED'
export const JUDGING_TEAM_GROUPS_LOADING = 'JUDGING_TEAM_GROUPS_LOADING'
export const JUDGING_TEAM_GROUPS_LOADED = 'JUDGING_TEAM_GROUPS_LOADED'
export const JUDGING_TEAM_GROUPS_ERROR = 'JUDGING_TEAM_GROUPS_ERROR'
export const JUDGING_TEAM_LOADING = 'JUDGING_TEAM_LOADING'
export const JUDGING_TEAM_LOADED = 'JUDGING_TEAM_LOADED'
export const JUDGING_TEAM_LOAD_ERROR = 'JUDGING_TEAM_LOAD_ERROR'
export const JUDGING_TEAM_SWITCHING = 'JUDGING_TEAM_SWITCHING'
export const JUDGING_TEAM_SWITCHED = 'JUDGING_TEAM_SWITCHED'
export const JUDGING_TEAM_SWITCH_ERROR = 'JUDGING_TEAM_SWITCH_ERROR'
export const JUDGING_TEAM_USER_REMOVING = 'JUDGING_TEAM_USER_REMOVING'
export const JUDGING_TEAM_USER_REMOVED = 'JUDGING_TEAM_USER_REMOVED'
export const JUDGING_TEAM_USER_REMOVE_ERROR = 'JUDGING_TEAM_USER_REMOVE_ERROR'
export const JUDGING_TEAM_USER_ADDING = 'JUDGING_TEAM_USER_ADDING'
export const JUDGING_TEAM_USER_ADDED = 'JUDGING_TEAM_USER_ADDED'
export const JUDGING_TEAM_USER_ADD_ERROR = 'JUDGING_TEAM_USER_ADD_ERROR'
export const JUDGING_SET_TEAM_LEAD_PROCESSING = 'JUDGING_SET_TEAM_LEAD_PROCESSING'
export const JUDGING_SET_TEAM_LEAD_PROCESSED = 'JUDGING_SET_TEAM_LEAD_PROCESSED'
export const JUDGING_SET_TEAM_LEAD_ERROR = 'JUDGING_SET_TEAM_LEAD_ERROR'

export const JUDGING_REMOVE_TEAM_LEAD_PROCESSING = 'JUDGING_REMOVE_TEAM_LEAD_PROCESSING'
export const JUDGING_REMOVE_TEAM_LEAD_PROCESSED = 'JUDGING_REMOVE_TEAM_LEAD_PROCESSED'
export const JUDGING_REMOVE_TEAM_LEAD_ERROR = 'JUDGING_REMOVE_TEAM_LEAD_ERROR'

export const JUDGING_SET_TEAM_LOCK = 'JUDGING_SET_TEAM_LOCK'
export const JUDGING_SET_TEAM_LOCK_LOADING = 'JUDGING_SET_TEAM_LOCK_LOADING'
export const JUDGING_SET_TEAM_LOCK_LOADED = 'JUDGING_SET_TEAM_LOCK_LOADED'
export const JUDGING_SET_TEAM_LOCK_ERROR = 'JUDGING_SET_TEAM_LOCK_ERROR'

export const JUDGING_TEAM_PROJECTS_LOADING = 'JUDGING_TEAM_PROJECTS_LOADING'
export const JUDGING_TEAM_PROJECTS_LOADED = 'JUDGING_TEAM_PROJECTS_LOADED'
export const JUDGING_TEAM_PROJECTS_LOAD_ERROR = 'JUDGING_TEAM_PROJECTS_LOAD_ERROR'

export const JUDGING_TEAM_PROJECTS_TAGS_LOADING = 'JUDGING_TEAM_PROJECTS_TAGS_LOADING'
export const JUDGING_TEAM_PROJECTS_TAGS_LOADED = 'JUDGING_TEAM_PROJECTS_TAGS_LOADED'
export const JUDGING_TEAM_PROJECTS_TAGS_ERROR = 'JUDGING_TEAM_PROJECTS_TAGS_ERROR'

export const JUDGING_TEAM_PROJECTS_ASSIGNING = 'JUDGING_TEAM_PROJECTS_ASSIGNING'
export const JUDGING_TEAM_PROJECTS_ASSIGNED = 'JUDGING_TEAM_PROJECTS_ASSIGNED'
export const JUDGING_TEAM_PROJECTS_ASSIGN_ERROR = 'JUDGING_TEAM_PROJECTS_ASSIGN_ERROR'

export const JUDGING_TEAM_RESET = 'JUDGING_TEAM_RESET'

export const JUDGING_SCHEDULE_TEAM_PROCESSING = 'JUDGING_SCHEDULE_TEAM_PROCESSING'
export const JUDGING_SCHEDULE_TEAM_PROCESSED = 'JUDGING_SCHEDULE_TEAM_PROCESSED'
export const JUDGING_SCHEDULE_TEAM_ERROR = 'JUDGING_SCHEDULE_TEAM_ERROR'
export const JUDGING_SCHEDULE_TEAM_IDLE = 'JUDGING_SCHEDULE_TEAM_IDLE'

export const TOGGLE_ORDER = 'TOGGLE_ORDER'

export const CONTACT_CREATING = 'CONTACT_CREATING'
export const CONTACT_CREATED = 'CONTACT_CREATED'
export const CONTACT_CREATE_ERROR = 'CONTACT_CREATE_ERROR'
export const CONTACT_CREATE_ERROR_RESET = 'CONTACT_CREATE_ERROR_RESET'

export const GROUP_PROJECTS_LOADING = 'GROUP_PROJECTS_LOADING'
export const GROUP_PROJECTS_LOADED = 'GROUP_PROJECTS_LOADED'
export const GROUP_PROJECTS_ERROR = 'GROUP_PROJECTS_ERROR'

export const ADD_GROUP_PROJECT = 'ADD_GROUP_PROJECT'
export const RESET_GROUP_PROJECT = 'RESET_GROUP_PROJECT'

export const CATEGORY_PROJECTS_LOADING = 'CATEGORY_PROJECTS_LOADING'
export const CATEGORY_PROJECTS_LOADED = 'CATEGORY_PROJECTS_LOADED'
export const CATEGORY_PROJECTS_ERROR = 'CATEGORY_PROJECTS_ERROR'

export const JUDGING_RUBRIC_DOWNLOAD_STATUS = 'JUDGING_RUBRIC_DOWNLOAD_STATUS'
export const JUDGING_RUBRIC_DOWNLOAD_ERROR = 'JUDGING_RUBRIC_DOWNLOAD_ERROR'
export const JUDGING_RUBRIC_UPLOAD_STATUS = 'JUDGING_RUBRIC_UPLOAD_STATUS'
export const JUDGING_RUBRIC_UPLOAD_ERROR = 'JUDGING_RUBRIC_UPLOAD_ERROR'
export const JUDGE_PAIRING_ERROR = 'JUDGE_PAIRING_ERROR'
export const JUDGE_PAIRING_STATUS = 'JUDGE_PAIRING_STATUS'
export const JUDGE_PAIRING_SCORE = 'JUDGE_PAIRING_SCORE'

export const PROJECTS_COUNT_LOADING = 'PROJECTS_COUNT_LOADING'
export const PROJECTS_COUNT_LOADED = 'PROJECTS_COUNT_LOADED'
export const PROJECTS_COUNT_ERROR = 'PROJECTS_COUNT_ERROR'
export const DONE_QUESTION_LOADING = 'DONE_QUESTION_LOADING'

// SEARCH ENGINE / PROJECT LIBRARY
export const UPDATE_SEARCH_ENGINE_QUERY = 'UPDATE_SEARCH_ENGINE_QUERY'
